<template>
  <div
    id="settingsMenu"
    ref="settingsMenu"
    v-nuxt-click-away="clickAway"
    data-testid="header-menubutton"
  >
    <span class="sr-only"> Settings Menu </span>

    <DropdownMenuButtonV2
      v-if="isFeatureEnabled"
      @toggleAction="toggleMenu"
      to="/carrier-profile"
      data-testid="dropdown-menu-button-carrier-profile"
    />
    <DropdownMenuButton
      v-else
      @toggleAction="toggleMenu"
      data-testid="dropdown-menu-button"
    />

    <slot name="menu-content">
      <ui-menu-anchor>
        <ui-menu v-model="open">
          <NuxtLink
            to="https://forms.gle/AobtohvG2NWyYVPa9"
            target="_blank"
            class="tw-no-underline"
            @click="useMixpanelTrack('lb2 profile send feedback button clicked')"
          >
            <DropdownItem
              icon="feedback"
              type="outlined"
            >
              <template #text>Send Feedback</template>
            </DropdownItem>
          </NuxtLink>
          <ui-menuitem-divider />
          <NuxtLink
            to="https://transport.acvauctions.com/legal"
            target="_blank"
            class="tw-no-underline"
            @click="useMixpanelTrack('lb2 legal button clicked')"
          >
            <DropdownItem
              icon="gavel"
              type="round"
            >
              <template #text>Legal</template>
            </DropdownItem>
          </NuxtLink>
          <ui-menuitem-divider />

          <DropdownItem
            icon="support_agent"
            type="filled"
            iconPosition="tw-items-start"
            @click="useMixpanelTrack('lb2 customer support button clicked')"
            :hasArrow="false"
          >
            <template #text>
              <div class="tw-flex tw-flex-col tw-gap-4 tw-text-left">
                <div class="tw-mb-2">Customer Support</div>
                <div
                  v-for="(item, index) in computedCustomerSupportInformation"
                  :key="index"
                >
                  <div class="tw-mb-2">{{ item.name }}</div>
                  <div
                    class="tw-mb-2"
                    v-if="item.amName"
                  >
                    {{ item.amName }}
                  </div>
                  <a
                    class="tw-mb-2 tw-block tw-font-medium tw-text-secondary-base tw-no-underline"
                    :href="`tel:${item.rawPhoneNumber}`"
                    target="_blank"
                  >
                    {{ item.phoneNumber }}
                  </a>
                  <a
                    class="tw-mb-2 tw-block tw-font-medium tw-text-secondary-base tw-no-underline"
                    :href="`mailto:${item.amEmail}`"
                    target="_blank"
                    v-if="item.amEmail"
                  >
                    {{ item.amEmail }}
                  </a>
                  <a
                    class="tw-mb-2 tw-block tw-font-medium tw-text-secondary-base tw-no-underline"
                    :href="`mailto:${item.email}`"
                    target="_blank"
                  >
                    {{ item.email }}
                  </a>
                  <div class="tw-mb-2">{{ item.businessHours }}</div>
                </div>
              </div>
            </template>
          </DropdownItem>
          <ui-menuitem-divider />

          <DropdownItem
            icon="logout"
            type="filled"
            @click="handleLogout()"
            data-testid="header-logout"
          >
            <template #text>Logout</template>
          </DropdownItem>
        </ui-menu>
      </ui-menu-anchor>
    </slot>
  </div>
</template>

<script setup>
const { logout } = useLogout();
const open = ref(false);
const isFeatureEnabled = ref(false);

const toggleMenu = () => {
  open.value = !open.value;

  if (open.value) {
    useMixpanelTrack('lb2 profile menu clicked');
  }
};

const clickAway = () => {
  open.value = false;
};

const handleLogout = () => {
  useMixpanelTrack('lb2 logout button clicked');

  logout();
};

const computedCustomerSupportInformation = computed(() => useCustomerSupportInformation());

onMounted(async () => {
  const { isCarrierProfileEnabled } = await useIsCarrierProfileEnabled();
  isFeatureEnabled.value = isCarrierProfileEnabled.value;
});
</script>

<style lang="scss" scoped>
@use '@/assets/scss/shared/constants';

:deep() {
  .mdc-button {
    padding: 0.375rem 0.75rem;
    transition: background-color 0.15s ease-in-out;

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
      border: 0;

      svg {
        @apply tw-text-black-500;
      }
    }

    svg {
      @apply tw-text-black-500;
    }
  }
  .mdc-deprecated-list {
    padding: 0;
  }
  .mdc-menu {
    .mdc-deprecated-list-divider {
      margin: 0;
    }
  }
  .mdc-deprecated-list-item {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 16px 20px;
    text-align: right;
    font-size: 16px;
    line-height: 1rem;
    height: auto;
    min-height: 48px;
    outline: none;
    transition: background-color 0.15s ease-in-out;
    .mdc-deprecated-list-item__graphic {
      margin-right: 0;
    }
    @apply tw-text-text-secondary;

    &:hover {
      background-color: #f3f3f3;
    }

    &:last-of-type {
      border: none;
    }
  }
  .mdc-menu {
    min-width: 300px;
  }
  .mdc-menu-surface {
    box-shadow:
      0px 0px 2px rgba(132, 132, 132, 0.14),
      0px 2px 2px rgba(132, 132, 132, 0.12),
      0px 1px 3px rgba(132, 132, 132, 0.2);
  }

  svg {
    @apply tw-text-text-secondary;
    // color: rgba(255, 255, 255, 0.8);
    font-size: 14px;

    &:hover {
      i,
      svg {
        color: rgba(255, 255, 255, 1);
      }
    }
  }
}
</style>
